<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DropdownLinks",

  computed: {
    links() {
      return this.$parent.dropdownLinks;
    },
  },
};
</script>
